import { render, staticRenderFns } from "./ProductServiceRiskFactors.vue?vue&type=template&id=33eea8ff&"
import script from "./ProductServiceRiskFactors.vue?vue&type=script&lang=js&"
export * from "./ProductServiceRiskFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports